module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_6_B-3205b8987d22dc3f219265f4a8f81d0b.gif";